export default "__VITE_ASSET__DmV$scXH__"